@if (!userPermissionsService.permissionsLoaded()) {
  <div class="permissions-loading" aria-live="polite" aria-label="Loading permissions">
    <app-spinner
      [display]="true"
      [diameter]="48"
      class="spinner-container"
      messageToDisplay="Loading your permissions..."
    />
  </div>
} @else if (showLayout) {
  <app-base-sidebar>
    <router-outlet />
  </app-base-sidebar>
} @else {
  <router-outlet />
}
